import { getGroupAttributes } from '@dispatch/shared/services';
import { useQuery } from 'react-query';

export const useGetGroupAttributes = (
  tenantId?: string,
  enabled = true,
  staleTime = 0
) => {
  const { data, status, refetch } = useQuery(
    ['groupAttributes'],
    () => getGroupAttributes(tenantId!),
    {
      staleTime,
      enabled: enabled && !!tenantId,
    }
  );

  return {
    groupAttributesData: data,
    groupAttributesStatus: status,
    groupAttributesRefetch: refetch,
  };
};
